/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import {ReasonBaseModel} from '../contracts/reason-base.model';
import {Cacheable} from '../../../decorators/cacheable.decorator';

@Injectable({
    providedIn: 'root'
})
export class ReasonService {
    // API endpoints
    reasonBaseActiveUrl = `${environment.specialOrdersBaseUrl}/api/reason/base/active`;
    reasonBaseUrl = `${environment.specialOrdersBaseUrl}/api/reason/base`;

    constructor(protected http: HttpClient) {
    }

    /**
     * Get all the active reasons base info from the API
     */
    @Cacheable()
    getActiveReasonOptions(): Observable<ReasonBaseModel[]> {
        return this.http.get<ReasonBaseModel[]>(this.reasonBaseActiveUrl);
    }

    /**
     * Get all the reasons base info from the API
     */
    @Cacheable()
    getAllReasonOptions(): Observable<ReasonBaseModel[]> {
        return this.http.get<ReasonBaseModel[]>(this.reasonBaseUrl);
    }
}
